module.exports = {
  formatDate: function (date, fmt) {
    if (date instanceof Date === false) {
      return ''
    }
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  },
  formatUTCDate: function (date, fmt) {
    if (date instanceof Date === false) {
      return ''
    }
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
    var o = {
      'M+': date.getUTCMonth() + 1, // 月份
      'd+': date.getUTCDate(), // 日
      'h+': date.getUTCHours(), // 小时
      'm+': date.getUTCMinutes(), // 分
      's+': date.getUTCSeconds(), // 秒
      'q+': Math.floor((date.getUTCMonth() + 3) / 3), // 季度
      'S': date.getUTCMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getUTCFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  },
  submitForm: function (params, options) {
    var method = options.method
    var action = options.action
    var target = options.target
    var form1 = document.createElement('form')
    form1.target = target
    for (var i = 0; i < params.length; i++) {
      var param = params[i]
      var input = document.createElement('input')
      input.name = param.name
      input.value = param.value
      form1.appendChild(input)
    }
    document.body.appendChild(form1)
    form1.method = method
    form1.action = action
    form1.submit()
    document.body.removeChild(form1)
  },
  getQueryStrings: function () {
    var result = {}
    var search = window.location.search.substr(1)
    var pairs = search.split('&')
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i]
      var kv = pair.split('=')
      if (kv.length === 2) {
        kv[1] = kv[1] ? kv[1].replace(/\+/g, '%20') : kv[1]
        result[kv[0]] = decodeURIComponent(kv[1])
      }
    }
    return result
  },
  getQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r !== null) {
      r[2] = r[2] ? r[2].replace(/\+/g, '%20') : r[2]
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  },
  getUrlFilename: function (url) {
    var u = new URL(url)
    var index = u.pathname.lastIndexOf('/')
    if (index !== -1) {
      return u.pathname.substring(index + 1)
    } else {
      return u.pathname
    }
  },
  parseParameters: function (str, splitchar) {
    var result = {}
    splitchar = splitchar || '&'
    var pairs = str.split(splitchar)
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i]
      var kv = pair.split('=')
      if (kv.length === 2) {
        kv[1] = kv[1] ? kv[1].replace(/\+/g, '%20') : kv[1]
        result[kv[0]] = decodeURIComponent(kv[1])
      }
    }
    return result
  },
  clipImage: function (imgElement, sx, sy, swidth, sheight, x, y, width, height, callback) {
    if (!imgElement) {
      return
    }
    var cav = document.createElement('canvas')
    cav.width = width
    cav.height = height
    var ctx = cav.getContext('2d')
    var img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')
    img.onload = function () {
      ctx.drawImage(img, sx, sy, swidth, sheight, x, y, width, height)
      callback(cav.toDataURL('image/png'))
    }
    img.src = imgElement.src
    // if (imgElement.complete) {
    //   ctx.drawImage(imgElement, sx, sy, swidth, sheight, x, y, width, height)
    //   callback(cav.toDataURL('image/png'))
    // } else {
    //   imgElement.onload = function () {
    //     ctx.drawImage(imgElement, sx, sy, swidth, sheight, x, y, width, height)
    //     callback(cav.toDataURL('image/png'))
    //   }
    // }
  },
  nextSibling: function (node) {
    var tempLast = node.parentNode.lastChild
    if (node === tempLast) return null
    var tempObj = node.nextSibling
    while (tempObj.nodeType !== 1 && tempObj.nextSibling != null) {
      tempObj = tempObj.nextSibling
    }
    return (tempObj.nodeType === 1) ? tempObj : null
  },
  prevSibling: function (node) {
    var tempFirst = node.parentNode.firstChild
    if (node === tempFirst) return null
    var tempObj = node.previousSibling
    while (tempObj.nodeType !== 1 && tempObj.previousSibling != null) {
      tempObj = tempObj.previousSibling
    }
    return (tempObj.nodeType === 1) ? tempObj : null
  },
  gotolink: function (href, target) {
    var a = document.createElement('a')
    a.href = href
    a.target = target
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  },
  loadScript: function (url, id, callback, keep) {
    callback = callback || function () { }
    if (id && document.getElementById(id) !== null) {
      var scriptElement = document.getElementById(id)
      var loaded = scriptElement.getAttribute('complete') === 'true'
      if (loaded) {
        callback()
      } else {
        if (navigator.userAgent.indexOf('MSIE') > 0) {
          var readystatechangeFn = function () {
            if (this.readyState === 'loaded' || this.readyState === 'complete') {
              callback()
            }
            scriptElement.removeEventListener('readystatechange', readystatechangeFn)
          }
          scriptElement.addEventListener('readystatechange', readystatechangeFn)
        } else {
          var loadedFn = function () {
            callback()
            scriptElement.removeEventListener('load', loadedFn)
          }
          scriptElement.addEventListener('load', loadedFn)
        }
      }
    } else {
      var domScript = document.createElement('script')
      domScript.id = id
      domScript.src = url
      if (navigator.userAgent.indexOf('MSIE') > 0) {
        domScript.onreadystatechange = function () {
          if (this.readyState === 'loaded' || this.readyState === 'complete') {
            domScript.setAttribute('complete', true)
            callback()
            this.onload = this.onreadystatechange = null
            if (keep === false) {
              this.parentNode.removeChild(this)
            }
          }
        }
      } else {
        domScript.onload = function () {
          domScript.setAttribute('complete', true)
          callback()
          this.onload = this.onreadystatechange = null
          if (keep === false) {
            this.parentNode.removeChild(this)
          }
        }
      }
      document.getElementsByTagName('head')[0].appendChild(domScript)
    }
  },
  loadCss: function (cssUrl, id) {
    if (id && document.getElementById(id) !== null) {
      return
    }
    var source = document.createElement('link')
    source.id = id
    source.rel = 'stylesheet'
    source.href = cssUrl
    document.body.appendChild(source)
  },
  stopPropagation: function (e) {
    if (e.stopPropagation) {
      e.stopPropagation()
    } else {
      e.cancelBubble = true
    }
  },
  downloadLink: function (link, target) {
    var aElement = document.createElement('a')
    aElement.href = link
    aElement.target = target
    document.body.appendChild(aElement)
    aElement.click()
    document.body.removeChild(aElement)
  },
  downloadImage: function (url) {
    var aElement = document.createElement('a')
    aElement.href = url
    aElement.target = '_blank'
    aElement.download = this.getUrlFilename(url)
    document.body.appendChild(aElement)
    aElement.click()
    document.body.removeChild(aElement)
  },
  downloadCrossImage: function (url, name) {
    fetch(url, {
      credentials: 'same-origin'
    })
      .then(response => {
        return response.blob()
      })
      .then(blob => {
        var objectUrl = window.URL.createObjectURL(blob)
        var aElement = document.createElement('a')
        aElement.href = objectUrl
        aElement.target = '_blank'
        aElement.download = name || this.getUrlFilename(url.match(/target=([^?&]+)/)[1])
        document.body.appendChild(aElement)
        aElement.click()
        document.body.removeChild(aElement)
      })
      .catch(err => {
        console.error(err)
      })
  },
  download: function (data, filename) {
    var blob = new Blob([data], {type: 'application/tar+gzip'})
    var element = document.createElement('a')
    if ('download' in element) { // 非IE下载
      element.download = filename
      element.style.display = 'none'
      element.href = URL.createObjectURL(blob)
      document.body.appendChild(element)
      element.click()
      URL.revokeObjectURL(element.href) // 释放URL对象
      document.body.removeChild(element)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, filename)
    }
  },
  playSound: function (src) {
    var borswer = window.navigator.userAgent.toLowerCase()
    if (borswer.indexOf('ie') >= 0) {
      // IE内核浏览器
      var embedElement = document.createElement('embed')
      embedElement.id = 'soundPlayer'
      embedElement.src = src
      embedElement.hidden = true
      embedElement.autostart = true
      embedElement.loop = false
      if (!document.getElementById('soundPlayer')) {
        document.body.appendChild(embedElement)
      }
      var embed = document.getElementById('soundPlayer')
      // 浏览器不支持 audion，则使用 embed 播放
      embed.volume = 100
      // embed.play() // 这个不需要
    } else {
      // 非IE内核浏览器
      var audioElement = document.createElement('audio')
      audioElement.id = 'soundPlayer'
      audioElement.src = src
      audioElement.hidden = true
      if (!document.getElementById('soundPlayer')) {
        document.body.appendChild(audioElement)
      }
      var audio = document.getElementById('soundPlayer')
      // 浏览器支持 audion
      audio.play()
    }
  },
  getBase64Image: function (img) {
    var canvas = document.createElement('canvas')
    canvas.width = img.naturalWidth
    canvas.height = img.naturalHeight
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    var dataURL = canvas.toDataURL('image/png')
    return dataURL
  },
  dataURLToBlob: function (dataURL) {
    var arr = dataURL.split(',')
    var matches = arr[0].match(/:(.*?);/)
    var mime = matches ? matches[1] : 'image/png'
    var bstr = atob(arr[1])
    var len = bstr.length
    var u8arr = new Uint8Array(len)
    while (len--) {
      u8arr[len] = bstr.charCodeAt(len)
    }
    return new Blob([u8arr], {type: mime})
  },
  getBlobImage: function (img) {
    var dataURL = this.getBase64Image(img)
    var blob = this.dataURLToBlob(dataURL)
    return blob
  },
  getImageBounds: function (url, callback) {
    callback = callback || function () {}
    var img = document.createElement('img')
    img.src = url
    img.style.display = 'none'
    img.onload = function () {
      callback(null, img.naturalHeight, img.naturalWidth)
      document.body.removeChild(img)
    }
    img.onerror = function (err) {
      console.error(err)
      callback(err)
      document.body.removeChild(img)
    }
    document.body.appendChild(img)
  },
  randomStr: function (len) {
    var result = ''
    var seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    var seedlength = seed.length
    for (var i = 0; i < len; i++) {
      var j = Math.floor(Math.random() * seedlength)
      result += seed[j]
    }
    return result
  },
  getSiteTitle: function () {
    var title = '管理平台'
    return title
  },
  openLink (url, target) {
    var ele = document.createElement('a')
    document.body.appendChild(ele)
    ele.href = url
    ele.target = target
    ele.click()
    document.body.removeChild(ele)
  },
  loadScripts: function (scripts, callback) {
    var item = scripts[0]
    if (item) {
      this.loadScript(item.url, item.id, () => {
        this.loadScripts(scripts.slice(1), callback)
      }, item.keep)
    } else if (callback) {
      callback()
    }
  },
  getImageDataFromUrl: function (url, callback) {
    var img = new Image()
    img.setAttribute('crossOrigin', 'Anonymous')
    img.onload = function (a) {
      var canvas = document.createElement('canvas')
      canvas.width = this.width
      canvas.height = this.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(this, 0, 0)
      var dataURI = canvas.toDataURL('image/jpg')
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return callback(new Blob([ia], { type: mimeString }))
    }
    img.src = url
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js